import { SearchCriteria } from "./search-criteria";

export class GetGiftCardUsingDetailsSearchCriteria extends SearchCriteria {
  public GiftCardInformationId: number;
}
